import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TokenStorageService } from '../services/token-storage.service';
import { LanguageService } from '../../i18n/language.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenStorage = inject(TokenStorageService);
  const token = tokenStorage.getToken();
  const language = inject(LanguageService).language();

  const requestUrl = new URL(req.url, window.location.origin);
  const apiUrl = new URL(environment.apiUrl, window.location.origin);
  const apiBasePath = apiUrl.pathname.replace(/\/+$/, '');

  const isApiRequest =
    requestUrl.origin === apiUrl.origin &&
    (requestUrl.pathname === apiBasePath || requestUrl.pathname.startsWith(`${apiBasePath}/`));

  if (!isApiRequest) {
    return next(req);
  }

  const isPublicRequest =
    requestUrl.pathname === `${apiBasePath}/login` ||
    requestUrl.pathname === `${apiBasePath}/token/refresh` ||
    requestUrl.pathname === `${apiBasePath}/token/logout` ||
    requestUrl.pathname === `${apiBasePath}/health` ||
    requestUrl.pathname.startsWith(`${apiBasePath}/public/`) ||
    requestUrl.pathname.startsWith(`${apiBasePath}/docs`);

  const apiRequest = req.clone({
    withCredentials: true,
    setHeaders: { 'Accept-Language': language },
  });
  if (isPublicRequest || !token) {
    return next(apiRequest);
  }

  return next(
    apiRequest.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
};
